import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
//stock routes

// skus routes
export const createSkuCategoryApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/stock/skus`, data);
};

// bulk upload (rows parsed from Excel in the browser)
export const bulkCreateSkusApi = (rows) =>
  axios.post(`${API_BASE_URL}/api/stock/skus/bulk`, { rows });
// super-admin only
export const bulkStoreEntriesApi = (rows) =>
  axios.post(`${API_BASE_URL}/api/stock/store/entry/bulk`, { rows });

export const updateSkuApi = (data) => {
  return axios.patch(`${API_BASE_URL}/api/stock/skus`, data);
};
export const getSkusApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/stock/skus`, { params });
};
// stock routes
export const addStockCategoryApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/stock/add`, data);
};
export const updateStockApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/stock/update`, data);
};
export const issueStockCategoryApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/stock/issue`, data);
};

export const getIssuedStockApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/stock/issue`, { params });
};

export const getIssuedStockDetailApi = (id) => {
  return axios.get(`${API_BASE_URL}/api/stock/issue/${id}`);
};

export const getStockTransactionApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/stock/transactions`, { params });
};

export const deleteStockApi = (id) => {
  return axios.delete(`${API_BASE_URL}/api/stock/delete/${id}`);
};

export const addStoreEntryApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/stock/store/entry`, data);
};
export const updateStoreEntryApi = (data) => {
  return axios.patch(`${API_BASE_URL}/api/stock/update`, data);
};
// stock edit request routes
export const createEditRequestApi = (data) =>
  axios.post(`${API_BASE_URL}/api/stock/edit-requests`, data);

export const reviewEditRequestApi = (id, data) =>
  axios.patch(`${API_BASE_URL}/api/stock/edit-requests/${id}/review`, data);

// supplier routes
export const addSupplierApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/supplier/add`, data);
};
export const getSuppliersListApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/supplier/list`, { params });
};
export const updateSupplierApi = (data) => {
  return axios.patch(`${API_BASE_URL}/api/supplier/update`, data);
};

// Several entries at once (any item / date / supplier / contractor). All or nothing.
export const addStoreEntriesMultiApi = (rows) =>
  axios.post(`${API_BASE_URL}/api/stock/store/entry/multi`, { rows });

// stock-register Excel import (one sheet per item) — one user only.
// payload: { rows, aliases?, dryRun? } — dryRun returns the preview, saves nothing.
export const importStockRegisterApi = (payload) =>
  axios.post(`${API_BASE_URL}/api/stock/store/entry/register-import`, payload);
